import React, { useState, useEffect, Fragment } from 'react';
import {Container, Card, ListGroup, Form, Row, Col, Button} from 'react-bootstrap'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { useLocation, useNavigate } from 'react-router-dom'
import { serviceGetItems, serviceGetConcepto, serviceGetcompanias, serviceGetProveedores, serviceGetDetalleMonitor } from '../../api/api-are-busqueda-caso';

const Busqueda360 = ({setListaDetalle, setItemSeleccionado}) => {
    const { state } = useLocation();
    let queryState = state?.queryState && state?.queryState;
    const history = useNavigate();

    const [loading, setLoading]=useState(false)
    const { roles, rutOrganizacion, nombre_organizacion } = Auth.currentUser(); 

    const [items, setItems] = useState(null);//useState([sisgen, asigResp, liqSiniAseg, envCartaCobro, recepRptaCiaTro]); 
    const [itemsFiltrados, setItemsFiltrados] = useState(null);
    const [flujoGestion, setFlujoGestion] = useState([]);
    const [companias, setCompanias] = useState([]);
    const [abogados, setAbogados] = useState([]);
    
    const [stateFlujoGestion, setStateFlujoGestion] = useState("");
    const [stateCompanias, setStateComapanias] = useState("");
    const [stateAbogados, setStateAbogados] = useState("");
    const [tipoGestion, setTipoGestion] = useState(null);
    const [tipoGestionWFL, setTipoGestionWFL] = useState(null);

    const [disabledFlujoGestion, setDisabledFlujoGestion] = useState(false)
    const [disabledCias, setDisabledCias] = useState(true)
    const [disabledAbogados, setDisabledAbogados] = useState(true)

    const [totalRojo, setTotalRojo] = useState("0");
    const [totalAmarillo, setTotalAmarillo] = useState("0");
    const [totalVerde, setTotalVerde] = useState("0");
    const [totalTotal, setTotalTotal] = useState("0");

    const [recuperDirectoEXT, setRecuperDirectoEXT] = useState("71006");

    const [esUsuarioExterno, setEsUsuarioExterno] = useState(false);

 useEffect(() => {
    
     if (roles && roles.length > 0) {
        setEsUsuarioExterno((roles?.filter((r) => (r .rol == '0070COBRAEX' || r .rol == '0070ABOEXT'))) ?.length > 0);        
    }
 }, [])

 useEffect(() => {

    console.log("esUsuarioExterno:", esUsuarioExterno);

    getFlujoGestion();

 }, [esUsuarioExterno])

 useEffect(()=>{   
    //console.log("queryState B360:", queryState);
    if (queryState) {
        let parametros = queryState;
        setStateFlujoGestion(parametros.flujo);
        setTipoGestion(parametros.tipoGestion);
        setTipoGestionWFL(parametros.tipoGestionWFL);
        setStateComapanias(parametros.compania);
        setStateAbogados(parametros.responsable);
        
        getItemsGestion(parametros.flujo, false, parametros.tipoGestionWFL, parametros.tipoGestion, parametros.compania, parametros.responsable);
        getDetalleCasos(parametros.idConcepto, parametros.color, parametros.flujo, parametros.tipoGestionWFL, parametros.tipoGestion, parametros.compania, parametros.responsable);

        //setTimeout(()=> verSemaforosAndGrilla(parametros?.flujo, parametros?.idConcepto, parametros?.color), 3000) ;    
    }
    queryState = null
    history('/consulta-gestion-360')
  },[state])
  
  /*const verSemaforosAndGrilla = async (flujo, idConcepto, color) => {
    console.log("flujo:", flujo);
    console.log("idConcepto:", idConcepto);
    console.log("color:", color);
    await getItemsGestion(flujo, false);
    await verDetalle(idConcepto, color);
  }*/

 const getFlujoGestion = async () => {
    const query = Buffer.from(JSON.stringify({ concepto: 71})).toString('base64');
    setLoading(true);
    const response = await serviceGetConcepto(query);
    setFlujoGestion(response);

    if (esUsuarioExterno && response.length > 0) {
        await preEvaluaFlujoGestion(recuperDirectoEXT, response);
    }

    setLoading(false);
 }
 const getCompanias = async () => {
    setLoading(true);
    const query = Buffer.from(JSON.stringify({ })).toString('base64');
    const response = await serviceGetcompanias(query);

    setCompanias(response);
    setLoading(false);
}
const getAbogados = async () => {
    setLoading(true);
    
    let response = [];

    if (esUsuarioExterno) {
        response = [{id:rutOrganizacion, nombre:nombre_organizacion}];
        setStateAbogados(rutOrganizacion);
        setDisabledFlujoGestion(true);
    } else {
        const query = Buffer.from(JSON.stringify({ idOrganizacion: rutOrganizacion, rol: '0070ABOEXT', tipoPersona: '0080PROVE00' })).toString('base64');
        response = await serviceGetProveedores(query);
    }
    setAbogados(response);

    setLoading(false);
}
const getItems = async (flujo, inicial) => {
    await getItemsGestion(flujo, inicial, tipoGestionWFL, tipoGestion, stateCompanias, stateAbogados);
}
const getItemsGestion = async (flujo, inicial, tgwfl, tg, cia, abo) => {

    const query = Buffer.from(JSON.stringify({ idOrganizacion: rutOrganizacion, flujo:flujo, tipoGestionWFL:tgwfl, tipoGestion:tg, inicial: inicial, compania: cia ? cia: 0, responsable: abo ? abo: 0 })).toString('base64');
    setLoading(true);
    const response = await serviceGetItems(query);

    setItems(response.length > 0 ? response : null);
    setLoading(false);
}

 useEffect(() => {

    let totalRojo = 0; let totalAmarillo = 0; let totalVerde = 0; let totalTotal = 0;
    let items_filtrados = [];
    if (items && items.length > 0) {        
        let map = {};
        items.forEach((item) => {
            if (item.despliegue === 1) {
                map[item.idConcepto] = item;
                items_filtrados.push(item);
            } else {
                map[item.idConcepto].verde = item.verde;
                map[item.idConcepto].amarillo = item.amarillo;
                map[item.idConcepto].rojo = item.rojo;
                map[item.idConcepto].CntTareas = item.CntTareas;

                totalRojo = totalRojo + parseInt(item.rojo);
                totalAmarillo = totalAmarillo + parseInt(item.amarillo);
                totalVerde = totalVerde + parseInt(item.verde);
                totalTotal = totalTotal + parseInt(item.CntTareas);
            }
        });
        setItemsFiltrados(items_filtrados);
    }
    setTotalRojo(totalRojo);
    setTotalAmarillo(totalAmarillo);
    setTotalVerde(totalVerde);
    setTotalTotal(totalTotal);
}, [items])

const preEvaluaFlujoGestion = async (flujo, flujoGestionList) => {    

    if (esUsuarioExterno) { 
        await evaluaFlujoGestion(flujo, flujoGestionList, false);
    } else {
        await evaluaFlujoGestion(flujo, flujoGestion, true);
    }
}
const evaluaFlujoGestion = async (flujo, flujoGestionList, inicial) => {    
    setStateFlujoGestion(flujo);

    let fg = flujoGestionList?.filter((f) => f.id ==flujo)

    console.log("flujoGestionList:", flujoGestionList);
    console.log("fg:", fg);

    setTipoGestionWFL(fg[0]?.agrupacion);
    setTipoGestion(fg[0]?.accion);

    getItems(flujo, inicial);

    if (flujo == 71002 || flujo == 71004 || flujo == 71006) {//Recupero Directa - Defensa Directo - Recupero DirectO EXT
        setDisabledAbogados(false);
        setDisabledCias(true);
        setStateComapanias("");
        getAbogados();
    }
    if (flujo == 71001 || flujo == 71003) {//Recupero entre Cias - Defensa entre Cias
        setDisabledAbogados(true);
        setDisabledCias(false);
        setStateAbogados("");
        getCompanias();
    }    
}
const verFlujosData=()=>{
    
    getItems(stateFlujoGestion, false);
}
const handleLimpliar=()=>{
    setStateFlujoGestion("");
    setItems(null);
    setStateComapanias("");
    setStateAbogados("");
    setDisabledCias(true);
    setDisabledAbogados(true);
    setListaDetalle([]);
    setItemsFiltrados(null);
}
const verDetalle = async (item, color, nivel) => { 
    item.nivelSeleccionado = nivel;
    setItemSeleccionado(item);
    await getDetalleCasos(item, color, stateFlujoGestion, tipoGestionWFL, tipoGestion, stateCompanias, stateAbogados);
}
const getDetalleCasos = async (item, color, flujo, tgwfl, tg, cia, abo) => { 
    
    setLoading(true);

    let filterFG = flujoGestion?.filter((f) => f.id == flujo)
    let filterAbo = abogados?.filter((f) => f.id == abo)
    let concepto = item.Concepto;

    //console.log("FG:", filterFG[0].nombre);
    //console.log("ABO:", filterAbo[0].nombre);
    //console.log("CONC:", concepto);

    let params = { idOrganizacion: rutOrganizacion, idConcepto: item.idConcepto, color: color, flujo: flujo, tipoGestionWFL:tgwfl, 
        tipoGestion:tg, compania: cia ? cia: 0, responsable: abo ? abo: 0, flujoGestion: filterFG[0].nombre, abogado: filterAbo[0]?.nombre, concepto: concepto }
    const query = Buffer.from(JSON.stringify(params)).toString('base64');
    const response = await serviceGetDetalleMonitor(query);
    localStorage.setItem('query', JSON.stringify(params))

    setLoading(false);

    setListaDetalle(response);
}

  return (
    <>
    <style type='text/css'>
    {`
    .btn-limpiar {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }    
    .btn-buscar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    `}
    </style>
    <Fragment>
    <LoadingComponent show={loading}/>
    <Container>
      <Container>            
            <Card className='mt-2'>
                <Card.Body>
                    <Row>
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                Flujo Gestión
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                style={{ fontSize: '14px'}}
                                name='flujoGestion'
                                onChange={(e) => preEvaluaFlujoGestion(e.target.value, null)}
                                value={stateFlujoGestion}
                                disabled={disabledFlujoGestion}
                            >
                            <option value={''}>Seleccione...</option>
                                {flujoGestion && flujoGestion
                                    .filter((c) => (esUsuarioExterno ? c.id > 71005 : c.id < 71005))
                                    .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                }
                            </Form.Select>
                        </Col>
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                Compañía Tercero
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                style={{ fontSize: '14px'}}
                                name='compania'
                                onChange={(e) => setStateComapanias(e.target.value)}
                                value={stateCompanias}
                                disabled={disabledCias}
                            >
                            <option value={''}>Seleccione...</option>
                                {companias && companias
                                    .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                }
                            </Form.Select>
                        </Col>
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                Responsable Asignado
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                style={{ fontSize: '14px'}}
                                name='abogado'
                                onChange={(e) => setStateAbogados(e.target.value)}
                                value={stateAbogados}
                                disabled={disabledAbogados}
                            >
                            <option value={''}>Seleccione...</option>
                                {abogados && abogados
                                    .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                }
                            </Form.Select>
                        </Col>
                    </Row>                    
                    <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                    <Row className='mt-2'>                                        
                        <Col className='d-flex align-items-end justify-content-end m-2'>
                            <Button className='m-2' variant='limpiar' onClick={handleLimpliar}>Limpiar</Button>
                            <Button className='m-2' variant='buscar' onClick={verFlujosData}>Consultar</Button>
                        </Col>
                    </Row>        
                </Card.Body>
            </Card>
            <Row className="show-grid">
                {itemsFiltrados && itemsFiltrados.map((item, key) => {  
                    return ( 
                    <Col md='3' style= {{'marginTop':'2px', 'cursor':'pointer'}}>
                        <ListGroup>
                            <ListGroup.Item><span style= {{'fontWeight':'bold', 'fontSize':'94%'}}>{item.Concepto}</span></ListGroup.Item>
                            <ListGroup.Item variant="danger" align="center" onClick={() => verDetalle(item, "rojo", item.nivel1)} >{item.nivel1} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Form.Label style= {{'padding':'3px', 'borderRadius': '5px', 'backgroundColor':'#f70404', 'color':'white', 'fontSize':'100%'}}>{item.rojo}</Form.Label></ListGroup.Item>
                            <ListGroup.Item variant="warning" align="center" onClick={() => verDetalle(item, "amarillo", item.nivel2)}>{item.nivel2} &nbsp;<Form.Label style= {{'padding':'3px', 'borderRadius': '5px', 'backgroundColor':'#FFC107', 'color':'white', 'fontSize':'100%'}}>{item.amarillo}</Form.Label></ListGroup.Item>
                            <ListGroup.Item variant="success" align="center" onClick={() => verDetalle(item, "verde", item.nivel3)}>{item.nivel3} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Form.Label style= {{'padding':'3px', 'borderRadius': '5px', 'backgroundColor':'#018e00', 'color':'white', 'fontSize':'100%'}}>{item.verde}</Form.Label></ListGroup.Item>                                
                            <ListGroup.Item align="center" onClick={() => verDetalle(item, "total", '')}> <span style= {{'fontWeight':'bold'}}>TOTAL</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Form.Label style= {{'padding':'3px', 'borderRadius': '5px', 'backgroundColor':'#673AB7', 'color':'white', 'fontSize':'100%'}}>{item.CntTareas}</Form.Label></ListGroup.Item>
                        </ListGroup>
                    </Col>  
                    )
                    })
                }                              
                {itemsFiltrados &&
                    <Col md='3' style= {{'marginTop':'2px'}}>
                        <ListGroup>
                            <ListGroup.Item><span style= {{'fontWeight':'bold', 'fontSize':'94%'}}>TOTAL PENDIENTES</span></ListGroup.Item>
                            <ListGroup.Item align="center">{itemsFiltrados && itemsFiltrados[0].nivel1} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <Form.Label style= {{'padding':'3px', 'borderRadius': '5px', 'backgroundColor':'gray', 'color':'white', 'fontSize':'100%'}}>{totalRojo}</Form.Label ></ListGroup.Item>
                            <ListGroup.Item align="center">{itemsFiltrados && itemsFiltrados[0].nivel2} &nbsp;<Form.Label style= {{'padding':'3px', 'borderRadius': '5px', 'backgroundColor':'gray', 'color':'white', 'fontSize':'100%'}}>{totalAmarillo}</Form.Label></ListGroup.Item>
                            <ListGroup.Item align="center">{itemsFiltrados && itemsFiltrados[0].nivel3} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Form.Label style= {{'padding':'3px', 'borderRadius': '5px', 'backgroundColor':'gray', 'color':'white', 'fontSize':'100%'}}>{totalVerde}</Form.Label></ListGroup.Item>                                
                            <ListGroup.Item align="center"> <span style= {{'fontWeight':'bold'}}>TOTAL</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Form.Label style= {{'padding':'3px', 'borderRadius': '5px', 'backgroundColor':'gray', 'color':'white', 'fontSize':'100%'}}>{totalTotal}</Form.Label></ListGroup.Item>
                        </ListGroup>
                    </Col>   
                }                   
            </Row>    
            <Row className="show-grid">
                <Col md={12} style= {{'marginTop':'10px'}}>
                    <div ><span style= {{'color':'#018e00'}}>(*) Para visualizar casos involucrados, ubicar gestión de interés y presionar nivel de evaluación. </span></div>
                </Col>
            </Row>
            <Row className="show-grid">
                <Col md={12}>
                    <div ><span style= {{'color':'#018e00'}}>(*) Para ver sólo gestiones pendientes con responsable asignado, seleccionar un Responsable. </span></div>
                </Col>
            </Row>                
        </Container>                 
    </Container>
    <style type='text/css'>
        {`
        .label {
            font-weight: bold;
            font-size: 14px;
        }
        `}
    </style>
    </Fragment>

    </>
  )
}
export default Busqueda360